"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBlogNotificationEmailsForSaving = exports.getBlogSettingsForSaving = exports.getAllowedBlogDomainsAsSelectInputOptions = exports.getSelectedBlogDomain = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _reselect = require("reselect");

var _selectors = require("settings-ui-sdk/Domains/selectors");

var _selectors2 = require("settings-ui-sdk/Blogs/selectors");

var _constants = require("settings-ui-sdk/Blogs/constants");

var _updateNotificationEmailsSelectors = require("../selectors/staging/updateNotificationEmailsSelectors");

var _constants2 = require("settings-ui-sdk/BlogNotificationEmails/constants");

var _UpdateBlogSettings = _interopRequireDefault(require("../stagedObjects/UpdateBlogSettings"));

var _selectors3 = require("settings-ui-sdk/Auth/selectors");

var getSelectedBlogDomain = (0, _reselect.createSelector)([_UpdateBlogSettings.default.getStagedProperty(_constants.DOMAIN), _selectors.getPrimaryBlogDomain, _selectors.getBlogDomains], function (stagedDomainName, primaryBlogDomain, blogDomains) {
  if (stagedDomainName === '') {
    return primaryBlogDomain;
  }

  return blogDomains.find(function (domain) {
    return domain.get('domain') === stagedDomainName;
  }) || (0, _immutable.Map)({
    domain: stagedDomainName
  });
});
exports.getSelectedBlogDomain = getSelectedBlogDomain;
var getAllowedBlogDomainsAsSelectInputOptions = (0, _reselect.createSelector)([_selectors.getBlogDomains, _selectors.getPrimaryBlogDomain, _selectors3.getIsEnterprise], function (blogDomains, primaryBlogDomain, hasMultiDomainHostingAccess) {
  return hasMultiDomainHostingAccess ? (0, _selectors.getDomainsAsSelectInputOptions)(blogDomains) : (0, _selectors.getDomainsAsSelectInputOptions)((0, _immutable.Map)((0, _defineProperty2.default)({}, primaryBlogDomain.id, primaryBlogDomain)));
});
exports.getAllowedBlogDomainsAsSelectInputOptions = getAllowedBlogDomainsAsSelectInputOptions;
var getBlogSettingsForSaving = (0, _reselect.createSelector)([_UpdateBlogSettings.default.getStagedObject, _UpdateBlogSettings.default.getStagedOrderedMapPropertyAsArray(_constants.ATTACHED_STYLESHEETS)], function (stagedObject, attachedStylesheetsArray) {
  var blogSettingsForSaving = stagedObject.merge((0, _defineProperty2.default)({}, _constants.ATTACHED_STYLESHEETS, attachedStylesheetsArray)).toJS();

  if (blogSettingsForSaving[_constants.PUBLIC_ACCESS_RULES]) {
    blogSettingsForSaving[_constants.PUBLIC_ACCESS_RULES] = [{
      type: 'LIST_MEMBERSHIP',
      ids: blogSettingsForSaving[_constants.PUBLIC_ACCESS_RULES]
    }];
  }

  return blogSettingsForSaving;
});
exports.getBlogSettingsForSaving = getBlogSettingsForSaving;
var getBlogNotificationEmailsForSaving = (0, _reselect.createSelector)([_selectors2.getBlogFromRoute, (0, _updateNotificationEmailsSelectors.getNotificationEmailIsEnabled)(_constants2.INSTANT_EMAIL), (0, _updateNotificationEmailsSelectors.getNotificationEmailIsEnabled)(_constants2.DAILY_EMAIL), (0, _updateNotificationEmailsSelectors.getNotificationEmailIsEnabled)(_constants2.WEEKLY_EMAIL), (0, _updateNotificationEmailsSelectors.getNotificationEmailIsEnabled)(_constants2.MONTHLY_EMAIL)], function (blogFromRoute, instantNotificationEmailsEnabled, dailyNotificationEmailsEnabled, weeklyNotificationEmailsEnabled, monthlyNotificationEmailsEnabled) {
  return {
    blogId: blogFromRoute.get('id'),
    data: {
      instant_enabled: instantNotificationEmailsEnabled,
      daily_enabled: dailyNotificationEmailsEnabled,
      weekly_enabled: weeklyNotificationEmailsEnabled,
      monthly_enabled: monthlyNotificationEmailsEnabled
    }
  };
});
exports.getBlogNotificationEmailsForSaving = getBlogNotificationEmailsForSaving;